let settings = JSON.parse(localStorage.getItem('viergradMenuSettings'));
// let settings = {
//   searchbar_visibility: false,
//   search_label_text: 'Suche',
//   lang_switcher_visibility: false,
//   animated_menu_button: true,
//   back_label_text: 'Zurück',
//   menu_structure: 'singl_open_page',
//   colors: {
//     font_color_regular: '#000000',
//     font_color_bold: '#000000',
//     link_hover_color: '#569e9f',
//     navigation_background_color: '#ffffff',
//     social_media_icons_color: '#569e9f',
//     social_media_icons_color_hover: '#68721d',
//   },
//   alignment: {
//     navigation: 'right',
//     navigation_content: 'left',
//     social_icons: 'left',
//     close_navigation_button: 'right',
//   },
// };
console.log('Settings: ', settings);

export default settings;
